import { cn } from "@faire/prototype-playground/lib/utils";
import React from "react";

interface CarouselHeaderProps {
  title: string;
  /** Optional supporting line under the title (e.g. a shipping perk). */
  subtitle?: string;
  shopAllLink?: {
    href: string;
    text?: string;
  };
  navigationButtons?: React.ReactNode;
  className?: string;
}

export default function CarouselHeader({
  title,
  subtitle,
  shopAllLink,
  navigationButtons,
  className = "",
}: CarouselHeaderProps) {
  return (
    <div
      className={cn(
        "flex items-baseline justify-between gap-2 pb-4",
        className
      )}
    >
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-start">
          <p
            className="text-fs-text-primary"
            style={{
              fontFamily: "Nantes, serif",
              fontWeight: 400,
              fontSize: "22px",
              lineHeight: "28px",
              letterSpacing: "-0.3px",
            }}
          >
            {title}
          </p>
        </div>
        {subtitle ? (
          <p className="type-fs-paragraph text-fs-text-primary">{subtitle}</p>
        ) : null}
      </div>
      <div className="flex items-center gap-2">
        {shopAllLink && (
          <a
            href={shopAllLink.href}
            className="type-fs-paragraph text-fs-text-primary underline transition-colors duration-500 ease-in-out hover:text-[#757575]"
          >
            {shopAllLink.text || "Shop all"}
          </a>
        )}
        {navigationButtons && (
          <div
            className="flex gap-2"
            style={{ marginLeft: shopAllLink ? "8px" : "0" }}
          >
            {navigationButtons}
          </div>
        )}
      </div>
    </div>
  );
}
